import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

const Seo = ({ title, description, noindex }) => {
  const businessName = useSelector((state) => state.configs?.businessName);
  const fullTitle = title ? `${title} | ${businessName || 'Online Store'}` : (businessName || 'Online Store');
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex" />}
    </Helmet>
  );
};

export default Seo;
